import React from 'react';
import logo from './logo.svg';
import QuestionModel from './QuestionModel.js';
import './App.css';
import { motion } from "framer-motion";

class Question extends React.Component {
	
  handleSubmit = (user) => {
    //saveUser(user).then(() =>
	//	alert('oh yeah');
    //  this.props.history.push('/question')
    //))
	//called like this: <a onClick={this.handleSubmit}>Start</a>
  }
    
  questionOneClicked() {
	let lastQuestion = this.state.lastQuestion;
	if (lastQuestion.correctIndex == 0) {
		// they got it right!
		this.resetWrongAnswers();
		// alert('props val: ' + this.props.grownUpMode);
		// alert('new grownup mode: ' + this.state.grownUpMode);
		var myQuestionModel = new QuestionModel(this.props.grownUpMode, this.props.questionSource);
		let randomQuestion = myQuestionModel.getRandomQuestion();
		this.setState({lastQuestion: randomQuestion});
		this.props.onAnswer(true, lastQuestion.Reference);
	} else {
		this.setState({firstWrong : true});
		this.props.onAnswer(false, lastQuestion.Reference);
	}
	this.forceUpdate();
  }
  
  questionTwoClicked = (user) => {
		let lastQuestion = this.state.lastQuestion;
	 	if (lastQuestion.correctIndex == 1) {
			// they got it right!
			this.resetWrongAnswers();
			// alert('props val: ' + this.props.grownUpMode);
			// alert('new grownup mode: ' + this.state.grownUpMode);
			var myQuestionModel = new QuestionModel(this.props.grownUpMode, this.props.questionSource);
			let randomQuestion = myQuestionModel.getRandomQuestion();
			this.setState({lastQuestion: randomQuestion});
			this.props.onAnswer(true, lastQuestion.Reference);
		} else {
			this.setState({secondWrong : true});
			this.props.onAnswer(false, lastQuestion.Reference);
		}
  }
  
  questionThreeClicked() {
		let lastQuestion = this.state.lastQuestion;
	 	if (lastQuestion.correctIndex == 2) {
			// they got it right!
			this.resetWrongAnswers();
			// alert('props val: ' + this.props.grownUpMode);
			// alert('new grownup mode: ' + this.state.grownUpMode);
			var myQuestionModel = new QuestionModel(this.props.grownUpMode, this.props.questionSource);
			let randomQuestion = myQuestionModel.getRandomQuestion();
			this.setState({lastQuestion: randomQuestion});
			this.props.onAnswer(true, lastQuestion.Reference);
		} else {
			this.setState({thirdWrong : true});
			this.props.onAnswer(false, lastQuestion.Reference);
		}
  }
  
  questionFourClicked() {
		let lastQuestion = this.state.lastQuestion;
		if (lastQuestion.correctIndex == 3) {
			// they got it right!
			this.resetWrongAnswers();
			// alert('props val: ' + this.props.grownUpMode);
			// alert('new grownup mode: ' + this.state.grownUpMode);
			var myQuestionModel = new QuestionModel(this.props.grownUpMode, this.props.questionSource);
			let randomQuestion = myQuestionModel.getRandomQuestion();
			this.setState({lastQuestion: randomQuestion});
			this.props.onAnswer(true, lastQuestion.Reference);
		} else {
			this.setState({fourthWrong : true});
			this.props.onAnswer(false, lastQuestion.Reference);
		}
  }
  
  questionOneEntered(event) {
	let lastQuestion = this.state.lastQuestion;
	if (event.key === "Enter") {
		this.questionOneClicked();
	}
  }
  
   // questionOneEntered = event => {
	  // let lastQuestion = this.state.lastQuestion;
	// alert('last question: ' + lastQuestion);
	// if (event.key === "Enter") {
		// alert('Question one entered.');
	// }
  // }
  
  questionTwoEntered(event) {
	let lastQuestion = this.state.lastQuestion;
	if (event.key === "Enter") {
		this.questionTwoClicked();
	}
  }

  questionThreeEntered(event) {
	let lastQuestion = this.state.lastQuestion;
	if (event.key === "Enter") {
		this.questionThreeClicked();
	}
  }

  questionFourEntered(event) {
	let lastQuestion = this.state.lastQuestion;
	if (event.key === "Enter") {
		this.questionFourClicked();
	}
  }
  
  resetWrongAnswers() {
	  this.setState({firstWrong : false});
	  this.setState({secondWrong : false});
	  this.setState({thirdWrong : false});
	  this.setState({fourthWrong : false});
  }
  
  constructor(props, onAnswer, grownUpMode, questionSource) {
		super(props);
		//alert('q grownUpMode: ' + props.grownUpMode);
		var myQuestionModel = new QuestionModel(props.grownUpMode, props.questionSource);
		let randomQuestion = myQuestionModel.getRandomQuestion();
		
		this.state = {
			showQuestion: false,
			showGetStarted: true,
			lastQuestion: randomQuestion,
			firstWrong: false,
			secondWrong: false,
			thirdWrong: false,
			fourthWrong: false,
			grownUpMode: props.grownUpMode,
			questionSource: props.questionSource,
			lastSource: props.questionSource
			//childClick : () => onAnswer
		};
		//alert("test: " + myQuestionModel.test);
		
		this.questionOneClicked = this.questionOneClicked.bind(this);
		this.questionTwoClicked = this.questionTwoClicked.bind(this);
		this.questionThreeClicked = this.questionThreeClicked.bind(this);
		this.questionFourClicked = this.questionFourClicked.bind(this);
		this.resetWrongAnswers = this.resetWrongAnswers.bind(this);
		
		this.questionOneEntered = this.questionOneEntered.bind(this);
		// this.questionTwoEntered = this.questionTwoEntered(this);
		// this.questionThreeEntered = this.questionThreeEntered(this);
		// this.questionFourEntered = this.questionFourEntered(this);
		
		//onAnswer();
		//this.props.onAnswer();	// this works !!
		//this.onAnswer = onAnswer.bind(this);
		//this.props.onAnswer = onAnswer.bind(this);
	}
	
	getQuestionClasses(wrongIndicator) {
		//alert('wrong? ' + wrongIndicator);
		if (!wrongIndicator)
			return "blank-answer";
		return "red-answer";
	}
	
	getQuestionHeaderClass(questionText) {
		//alert('wrong? ' + wrongIndicator);
		if (questionText.length >= 50)
			return "Question-header-verbose";
		return "Question-header";
	}
	
	// componentWillMount() {
      // document.addEventListener("questionOneEntered", this.questionOneEntered.bind(this));	// onKeyDown
	// }
  
  render() {
	  if (this.props.questionSource != this.state.lastSource) {
		var myQuestionModel = new QuestionModel(this.props.grownUpMode, this.props.questionSource);
		let randomQuestion = myQuestionModel.getRandomQuestion();
		this.setState({lastQuestion: randomQuestion});
		this.setState({lastSource: this.props.questionSource});
	  }
	  let sourceCapitalized = this.props.questionSource.charAt(0).toUpperCase() + this.props.questionSource.slice(1);

      let randomQuestion = this.state.lastQuestion;
	  //alert('source: ' + this.props.questionSource);
	  
	  
	  //alert("last question: " + lastQuestion);
	  //alert("test2: " + lastQuestion.test);
	  
	  //alert('random question correct index = ' + randomQuestion.correctIndex);
	  //this.setState({lastQuestion: randomQuestion});
	  //alert('displayOne: ' + randomQuestion.displayOne);
	  let questionText = randomQuestion.Text;
	  questionText = questionText.replace("bbb", " ________");
	  questionText = questionText.replace("Bbb", " ________");
	  //alert("test2: " + questionText);
	  
	  let question1 = randomQuestion.displayOne;
	  let question2 = randomQuestion.displayTwo;
	  let question3 = randomQuestion.displayThree;
	  let question4 = randomQuestion.displayFour;
//	  alert('correct: ' + randomQuestion.correctIndex);

	  let questionOneClasses = this.getQuestionClasses( this.state.firstWrong );
	  let questionTwoClasses = this.getQuestionClasses( this.state.secondWrong );
	  let questionThreeClasses = this.getQuestionClasses( this.state.thirdWrong );
	  let questionFourClasses = this.getQuestionClasses( this.state.fourthWrong );
	  let questionHeaderClass = this.getQuestionHeaderClass(questionText);
	  
	  let longestAnswerLength = Math.max(question1.length, question2.length, question3.length, question4.length);
	  let fontClass = "answer-text";
	  if (longestAnswerLength >= 40)
		fontClass = "answer-text-small";
	
	  // question count
	  let correctQuestionCount = this.props.correctQuestionCount;
	  let roundedCount = parseInt(correctQuestionCount);
	  roundedCount = Math.round(roundedCount);
	  let pointOrPoints = "points";
	  if (roundedCount === 1) {
		  pointOrPoints = "point";
	  }
	  	  
	  return (
		<div className="App">
		
		  <header role="h2" className={questionHeaderClass}>
			{questionText}
		  </header>
		  
		  
		  
		  	<div className="Question-count">
				&nbsp;
			</div>
			<div className="Question-count-number">
				{roundedCount}
			</div>
			<div className="Question-count-label">
				{pointOrPoints}
			</div>
			
			<div className="ESV-label">
				{sourceCapitalized}<br/>
				&nbsp;&nbsp;&nbsp;&nbsp;ESV <sup><a href="#esv">[*]</a></sup>
			</div>
		  
		  
		  <div className={fontClass}>
			  <div class="redline"></div>		  
			  <div role="button" className={questionOneClasses} onKeyDown={event => {this.questionOneEntered(event);}} tabindex="1" onClick={() => {this.questionOneClicked();}}>
				{question1}
			  </div>
			  <div class="blueline"></div>		  
			  <div role="button" className={questionTwoClasses} onKeyDown={event => {this.questionTwoEntered(event);}} tabindex="2" onClick={() => {this.questionTwoClicked();}}>
				{question2}
			  </div>
			  <div class="blueline"></div>
			  <div role="button" className={questionThreeClasses} onKeyDown={event => {this.questionThreeEntered(event);}} tabindex="3" onClick={() => {this.questionThreeClicked();}}>
				{question3}
			  </div>
			  <div class="blueline"></div>
			  <div role="button" className={questionFourClasses} onKeyDown={event => {this.questionFourEntered(event);}} tabindex="4" onClick={() => {this.questionFourClicked();}}>
				{question4}
			  </div>
		  </div>
		</div>
	  );
  }
}

export default Question;
